import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { CrumpType } from '@wajeez-web/core/types';
import { useProductSelector } from '@wajeez-web/stores/product';

export const PoliciesCrump: CrumpType = ({ params }): JSX.Element => {
  const { byIdMultilingual } = useProductSelector((s) => s.policies);

  return (
    <ReturnTranslatedText
      text={`breadCrumbs.${byIdMultilingual.data?.profiles?.[0]?.title}`}
      origintext={byIdMultilingual.data?.profiles?.[0]?.title}
    />
  );
};
